<template>
    <div class="close-foot">
      <div class="close-foot-text">
        <div class="close-foot-content">{{$t('GDriver_Optimization_CGbL_CwTS')}}</div>
        <img
          :src="require('../../images/icon_close.png')"
          alt=""
          class="close"
          @click="close()"
        />
      </div>
      <div class="close-foot-btn">
        <div class="foot-btn quit" @click="close('send')">{{$t('GDriver_Optimization_rKFb_Csoz')}}</div>
        <div :class="['foot-btn', 'confirm', `confirm-${location_country}`]" @click="confirm">{{$t('GDriver_Optimization_sLqo_jTpP')}}</div>
      </div>
    </div>
</template>
<script>
import {  mapState, mapMutations } from "vuex";
import { getEnd } from '../../tools/utils'
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["_dialog_close", "_uuid"]),
    location_country() {
      const query = new URLSearchParams(location.search);
      return query.get("location_country");
    },
    params() {
      return new URLSearchParams(location.search);
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    close(type) {
      this.setState({
        _dialog_close: false,
      });
      if(type === 'send') {
        try{
          Omega.trackEvent("ibt_appbar_back_toast_quit_ck", "", {
            channel: this.params.get("channel") || "",
            end: getEnd(),
            oid: this.params.get("oid") || Omega.getOmgid(),
            location_country_code: this.location_country,
            driver_id: this.params.get("uid") || this._uuid + ""
          });
        } catch(e) {
        }
      }
      
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: -1
        });
      Fusion.interceptCloseButton && Fusion.interceptCloseButton({
        jsCallback: '_PAGE_CLOSE_BUTTON'
      }, () => {});
    },
    confirm() {
      try{
        Omega.trackEvent("ibt_appbar_back_toast_continue_ck", "", {
          channel: this.params.get("channel") || "",
          end: getEnd(),
          oid: this.params.get("oid") || Omega.getOmgid(),
          location_country_code: this.location_country,
          driver_id: this.params.get("uid") || this._uuid + ""
        });
      }catch(e) {

      }
      Fusion.closePage && Fusion.closePage({}, () => {});
      Fusion.resetBack &&
        Fusion.resetBack({
          reset: -1
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.close-foot {
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  padding: 0.32rem 0.32rem;
  box-sizing: border-box;
  color: #91a0b4;
  background: #ffffff;
  border-radius: 0.3rem 0.3rem 1px 1px;
  .close-foot-text {
    color: #000;
    font-size: 0.4rem;
    font-weight: bold;
    position: relative;
    .close-foot-content {
      width: 90%;
      display: inline-block;
    }
    .close {
      width: 0.48rem;
      position: absolute;
      top: 0;
    }
  }
  .close-foot-btn {
    display: flex;
    justify-content: space-between;
    .foot-btn {
      margin-top: 0.9rem;
      width: 3.1rem;
      height: 1rem;
      line-height: 1.08rem;
      border-radius: 0.12rem;
      text-align: center;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .quit {
      border: 1px #666 solid;
      color: #666;
    }
    .confirm {
      background: rgb(255, 114, 38);
      color: #fff;
    }
    .confirm-BR {
      background: #FFDB16;
      color: #333;
    }
  }
}
</style>

